import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { normalizeAmount } from '../../utils/transformer.util';
import {
  Button,
  Select,
  SearchSelect,
  Input
} from '../../components/base/index';

const MySwal = withReactContent(Swal);

export default class PengaturanRombel extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._getPrmStaffRombelOptions = this._getPrmStaffRombelOptions.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
    this.onClickAdd = this.onClickAdd.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          listRombel: [],
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    if (isEdit && data) {
      this._setForm(data);
    }
    this._onSearchContent();
    this._getSchoolUnitsOptions();
    this._getPrmStaffRombelOptions();
  }


  async _getPrmStaffRombelOptions(filters = {}) {
    const { getPrmStaffRombelOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffRombelOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _setForm(data) {
    const { user } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    console.log({label: data.code+" - "+data.name, value:data.code})

    try {
      this.setState({
        form: {
          value: {
            id: data.id,
            staff: {value:data.code, label: data.code+" - "+data.name} ,
            description: data.description,
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'perwakilan_id') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              perwakilan_id: value,
              units_id: '',
            },
          },
        }));
        this._getSchoolUnitsOptions({ perwakilan_id: value.value });
        // if(value.value == 'all'){
        // this._onSearchContent();
        // }
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value)
          ? param.find(i => i.value == value.value).attributes.levels_id
          : '';

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              classrooms_id: '',
              levels_id: levels_units,
              units_id: value,
            },
          },
        }));
      }
      this._onSearchContent();
    });
  }

  async _onSearchContent(params = {}) {
    const { filters, param } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;


    this.setState(async () => {
      try {
        const { handleListRombels, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleListRombels({
          organizations_id,
          units_id: school_unit.id,
          filters,
        });
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listRombel: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listRombel: [],
            },
          },
        }));
      }
      // }
    });
  }

  async onSubmit() {
    const { history, handleSaveMasterPositions } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleSaveMasterPositions(value);
    history.push('/dashboard/pengaturan/jabatan');
  }

  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { listRombel, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(listRombel));
    newList.forEach((item) => {
      item.is_active = isBlocked;
    });

    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          listRombel: newList,
        },
      },
    }));
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;
    //   if (name === 'staff'){
    //     console.log(value)
    //     const selectedStaff = param.staff.find(
    //       (item) => item.value == value.value
    //     )
    //     var parts = selectedStaff.label.split(' - ');
    //     const code = selectedStaff.label.split(' - ')[0].trim();
    // const staff_name = parts.length > 1 ? parts[1].trim() : '';
    // form.value.name = staff_name;
    // form.value.code = code;
    //   }
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
       
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      // if (name === 'classes_id') {
      //   this._getParamOptionsAcademics( 'classrooms', {classes_id: value, organizations_id });
      // }
      if (name === 'is_active' && !inputArray) {
        this._setIsBlocked(value);
      }
      if (name === 'levels_id') {
        this._getClassesOptions({ filters: { levels_id: [value] } });
      }
      if (name === 'classes_id') {
        const param = this.state.param.classes_prm;
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              // graduate: param.find(i => i.value == value).attributes.graduate,
            },
          },
        }));
      }
    });
  }

  async onClickSubmit() {
    const { history, handleSaveMasterPositions, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    await handleSaveMasterPositions(value);
    history.push('/dashboard/pengaturan/jabatan');
    // history.go(0);
  }

  async onClickUpdate() {
    const { history, handleEditMasterPositions, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    await handleEditMasterPositions(value);
    history.push('/dashboard/pengaturan/jabatan');
  }

  async onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/pengaturan/tambah-rombel', {
      data: val,
      isEdit: true,
    });
    // history.go(0);
  }

  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/pengaturan/tambah-rombel', {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  render() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { form, filters, param } = this.state;
    const { listRombel } = form.value;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const dataGet = data || '';
    
    return (
      <div className="manage-registration">
        <h1>Pengaturan Rombel</h1>
        <hr />
        <div className="absensi-rekap__custom-form">

        </div>
          <div className="student-list__header">
            <div className="student-list__button">
                <Button
                  type="button"
                  title="Tambah Pengaturan Rombel"
                  onClick={this.onClickAdd}
                />
            </div>
          </div>
        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table">
              <thead>
                <tr style={{textAlign:"center"}}>
                  <th>No</th>
                  <th>Jenjang</th>
                  <th>Kode Unit</th>
                  <th>Opsi</th>
                </tr>
              </thead>
              <tbody>
                {map(listRombel, (list, idx) => (
                  <tr key={`budget_row_${idx}`}>
                    <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                      {idx + 1}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                      {list.level_name}
                    </td>
                    <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                      {list.unit_code}
                    </td>
                    {this._renderButtons(list)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
PengaturanRombel.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
PengaturanRombel.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
